/**
 * 课程分享（抢听）
 */
import $share from '@/api/modules/share'
import { AsyncRequest } from '@/utils/request'

const state = {
  courseShareInfo: {}
}

const getters = {
  courseShareInfo: state => {
    return state.courseShareInfo
  }
}

const mutations = {
  setCourseShareInfo: (state, info) => {
    state.courseShareInfo = info
  }
}

const actions = {
  // 获取课程分享
  getCourseShareInfo({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      request: () => $share.getCourseShareInfo(payload),
      resolve: (info) => commit('setCourseShareInfo', info)
    })
  },
  shareParticipation({ commit }, payload) {
    return AsyncRequest({
      loading: true,
      
      request: () => $share.shareParticipation(payload)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
